import { useEffect } from "react"
import { useFormikContext } from "formik"
import { DLGAFormEvent } from "../../../../helpers/WatcherDL/DLEvents"
import { FormValues } from "../types"

export const FormikStatusWatcher = () => {
  const { dirty, isValid } = useFormikContext<FormValues>()

  useEffect(() => {
    if (isValid && dirty) {
      DLGAFormEvent({
        eventCategory: "allFieldsFilled",
        eventAction: "formReadyToSubmit",
        placement: "main",
      })
    }
  }, [isValid, dirty])

  return null
}
